module.exports = __webpack_public_path__ + "img/1.03313162.jpg";